export default __webpack_public_path__ + "static/media/two.780b32a7.jpeg";